export const init_viewport = {
    "longitude": 2.8, 
    "latitude": 14.2,
    "zoom": 1.8,
    "bearing": 0,
    "pitch": 0,
    "transitionDuration": 500
}

export const init_layer = 'ElDorado'
export const init_subgroup = ''
export const active_dataset = 'ElDorado'